import styled from 'styled-components';
import { darken, lighten, rgba } from 'polished';

const StyledCalcItem = styled.div`
  flex: 1;
  margin: 1px;
  padding: 10px;
  text-align: center;
  color: #fff;
  font-size: 1.3em;
  background: linear-gradient(90deg, ${(props) => lighten(0.15, '#fb8c00')}, ${(props) => '#fb8c00'});
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${(props) => rgba(darken(0.2, '#fb8c00'), 0.4)};

  &:hover,
  &.active {
    cursor: pointer;
    background: linear-gradient(90deg, ${(props) => '#fb8c00'}, ${(props) => darken(0.1, '#fb8c00')});
  }
`;

const CalcItem = ({ value, onClick }) => {
  return <StyledCalcItem onClick={() => onClick(value)}>{value}</StyledCalcItem>;
};

export default CalcItem;
